import { createSelector } from 'reselect'
import { AppState } from 'store/types'

/**
 * @param state - the application state
 * @returns properties - the properties reducer
 */
export const selectPropertiesReducer = (state: AppState) => state.properties

/**
 * Gets the properties' data from the properties reducer
 */
export const selectProperties = createSelector(
  selectPropertiesReducer,
  propertiesState => propertiesState.data,
)

/**
 * Gets the properties' isFetching from the properties reducer
 */
export const selectPropertiesIsFetching = createSelector(
  selectPropertiesReducer,
  propertiesState => propertiesState.isFetching,
)

/**
 * Gets the properties' meta from the properties reducer
 */
export const selectPropertiesMeta = createSelector(
  selectPropertiesReducer,
  propertiesState => propertiesState.meta,
)
